// extracted by mini-css-extract-plugin
export default {"main":"mainWrapper_main__+FpC3","bannerMain":"mainWrapper_bannerMain__2W7id"};